import React, { useState } from 'react';
import { CalendarIcon, MailIcon, BellIcon, ClockIcon, UserIcon, ToggleLeftIcon, ToggleRightIcon, ChevronDownIcon, CheckIcon, AlertCircleIcon } from 'lucide-react';
export const FollowUpPanel = () => {
  const [autoFollowUp, setAutoFollowUp] = useState(false);
  const [playbook, setPlaybook] = useState('standard');
  const [rules, setRules] = useState({
    rule1: true,
    rule2: false,
    rule3: false
  });
  const toggleRule = (rule: keyof typeof rules) => {
    setRules(prev => ({
      ...prev,
      [rule]: !prev[rule]
    }));
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4 sticky top-24" data-id="element-74">
      <h2 className="text-lg font-medium mb-3 flex items-center gap-2" data-id="element-75">
        <BellIcon size={18} className="text-red-600 flex-shrink-0" data-id="element-76" />
        <span className="truncate" data-id="element-77">Opfølgning</span>
      </h2>
      {/* Seneste opfølgning */}
      <div className="mb-4" data-id="element-78">
        <h3 className="text-sm font-medium text-gray-700 mb-2 truncate" data-id="element-79">
          Seneste opfølgning
        </h3>
        <div className="bg-gray-50 rounded-lg p-3" data-id="element-80">
          <div className="flex items-center justify-between mb-1" data-id="element-81">
            <div className="flex items-center gap-1 text-sm" data-id="element-82">
              <CalendarIcon size={14} className="text-gray-500 flex-shrink-0" data-id="element-83" />
              <span className="truncate" data-id="element-84">I går, 14:30</span>
            </div>
            <div className="flex items-center gap-1 text-sm" data-id="element-85">
              <MailIcon size={14} className="text-blue-500 flex-shrink-0" data-id="element-86" />
              <span className="truncate" data-id="element-87">Mail</span>
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm mb-1" data-id="element-88">
            <UserIcon size={14} className="text-gray-500 flex-shrink-0" data-id="element-89" />
            <span className="truncate" data-id="element-90">Mette Hansen</span>
          </div>
          <p className="text-xs text-gray-600 line-clamp-2" data-id="element-91">
            Sendte opfølgning med tilbud om online gennemgang af løsningen.
          </p>
        </div>
      </div>
      {/* Action button */}
      <div className="mb-4" data-id="element-92">
        <button className="w-full bg-red-600 text-white rounded-md py-2 text-sm font-medium flex items-center justify-center gap-1 hover:bg-red-700" data-id="element-93">
          <MailIcon size={14} className="flex-shrink-0" data-id="element-94" />
          <span className="truncate" data-id="element-95">Send opfølgning</span>
        </button>
      </div>
      {/* Automatisk opfølgning */}
      <div className="mb-4" data-id="element-96">
        <div className="flex items-center justify-between mb-3" data-id="element-97">
          <h3 className="text-sm font-medium text-gray-700 truncate" data-id="element-98">
            Automatisk opfølgning
          </h3>
          <button onClick={() => setAutoFollowUp(!autoFollowUp)} className="flex items-center ml-2" data-id="element-99">
            {autoFollowUp ? <ToggleRightIcon size={20} className="text-red-600 flex-shrink-0" data-id="element-100" /> : <ToggleLeftIcon size={20} className="text-gray-400 flex-shrink-0" data-id="element-101" />}
          </button>
        </div>
        {autoFollowUp && <div className="space-y-4" data-id="element-102">
            {/* Playbook selection */}
            <div data-id="element-103">
              <label className="text-xs text-gray-500 block mb-1 truncate" data-id="element-104">
                Vælg playbook
              </label>
              <div className="relative" data-id="element-105">
                <select className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm appearance-none" value={playbook} onChange={e => setPlaybook(e.target.value)} data-id="element-106">
                  <option data-id="element-107">Standard</option>
                  <option data-id="element-108">Høj interesse</option>
                  <option data-id="element-109">Lav aktivitet</option>
                </select>
                <ChevronDownIcon size={16} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" data-id="element-110" />
              </div>
              {playbook === 'standard' && <div className="mt-2 text-xs text-gray-600 bg-gray-50 p-2 rounded" data-id="element-111">
                  <div className="flex items-center gap-1 mb-1" data-id="element-112">
                    <MailIcon size={12} className="flex-shrink-0" data-id="element-113" />
                    <span className="truncate" data-id="element-114">Mail D+2</span>
                  </div>
                  <div className="flex items-center gap-1 mb-1" data-id="element-115">
                    <MailIcon size={12} className="flex-shrink-0" data-id="element-116" />
                    <span className="truncate" data-id="element-117">Mail D+7</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-118">
                    <span className="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" data-id="element-119"></span>
                    <span className="truncate" data-id="element-120">Opkald D+10</span>
                  </div>
                </div>}
            </div>
            {/* Rules */}
            <div data-id="element-121">
              <label className="text-xs text-gray-500 block mb-1 truncate" data-id="element-122">
                Regler
              </label>
              <div className="space-y-2" data-id="element-123">
                <div className="flex items-start gap-2 cursor-pointer" onClick={() => toggleRule('rule1')} data-id="element-124">
                  <div className={`w-4 h-4 border rounded flex items-center justify-center mt-0.5 flex-shrink-0 ${rules.rule1 ? 'bg-red-600 border-red-600' : 'border-gray-300'}`} data-id="element-125">
                    {rules.rule1 && <CheckIcon size={12} className="text-white" data-id="element-126" />}
                  </div>
                  <span className="text-xs line-clamp-2" data-id="element-127">
                    Send ved "Senest set" &gt; 48t uden accept
                  </span>
                </div>
                <div className="flex items-start gap-2 cursor-pointer" onClick={() => toggleRule('rule2')} data-id="element-128">
                  <div className={`w-4 h-4 border rounded flex items-center justify-center mt-0.5 flex-shrink-0 ${rules.rule2 ? 'bg-red-600 border-red-600' : 'border-gray-300'}`} data-id="element-129">
                    {rules.rule2 && <CheckIcon size={12} className="text-white" data-id="element-130" />}
                  </div>
                  <span className="text-xs line-clamp-2" data-id="element-131">
                    Send ved "Klik på Best" + "Tilvalg åbnet" uden accept
                  </span>
                </div>
                <div className="flex items-start gap-2 cursor-pointer" onClick={() => toggleRule('rule3')} data-id="element-132">
                  <div className={`w-4 h-4 border rounded flex items-center justify-center mt-0.5 flex-shrink-0 ${rules.rule3 ? 'bg-red-600 border-red-600' : 'border-gray-300'}`} data-id="element-133">
                    {rules.rule3 && <CheckIcon size={12} className="text-white" data-id="element-134" />}
                  </div>
                  <span className="text-xs line-clamp-2" data-id="element-135">
                    Eskalér til salgsleder ved margin&lt;min % og 2 afslag
                  </span>
                </div>
              </div>
            </div>
          </div>}
      </div>
      {/* Status chips */}
      <div className="flex flex-wrap gap-2 mb-2" data-id="element-136">
        <div className={`text-xs px-2 py-1 rounded-full ${autoFollowUp ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-137">
          Auto {autoFollowUp ? 'ON' : 'OFF'}
        </div>
        <div className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800 flex items-center gap-1" data-id="element-138">
          <ClockIcon size={12} className="flex-shrink-0" data-id="element-139" />
          <span className="truncate" data-id="element-140">Næste: Ons 14:00</span>
        </div>
      </div>
      {/* Alert */}
      <div className="mt-4 border-t border-gray-100 pt-4" data-id="element-141">
        <div className="flex items-start gap-2 text-sm text-yellow-700" data-id="element-142">
          <AlertCircleIcon size={16} className="text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-143" />
          <span className="line-clamp-2" data-id="element-144">
            Kunde har besøgt tilbuddet 5 gange, men ikke accepteret endnu
          </span>
        </div>
      </div>
    </div>;
};